<template>
  <a-layout-header class="header">
    <div class="guide-wrapper" v-scroll="handleScroll">
     <a href="#" @click="handleClick">
        <img
          :src="logos"
          class="header-image"
          width="150"
          :srcset="
            `${logos.logo_500} 500w, ${logos.logo_800} 800w, ${logos.logo_1080} 1080w, ${logos.logo_1600} 1600w, ${logos.logo_1800} 1800w, ${logos.logo_2000} 2000w, ${logos.logo_2196} 2196w`
          "
          sizes="(max-width: 479px) 50vw, (max-width: 767px) 27vw, 150px"
        />
      </a>
      <ul class="nav__links w-nav-menu">
        <a href="#" @click="handleClick" class="nav-links w-nav-link"
          >Tilbake hjem</a
        >
      </ul>
    </div>
  </a-layout-header>
</template>

<script>
import LoginModal from "@/components/modals/LoginModal.vue";
import MainNavBar from "./MainNavbar";
import { NavigationFailureType, isNavigationFailure } from 'vue-router'
let logos = {
  logo_500: require("@/assets/images/fujilogo.png"),
  logo_800: require("@/assets/images/fujilogo-p-500.png"),
  logo_1080: require("@/assets/images/fujilogo-p-800.png"),
  logo_1600: require("@/assets/images/fujilogo-p-1080.png"),
  logo_2000: require("@/assets/images/fujilogo-p-2000.png"),
  logo_2196: require("@/assets/images/fujilogo.png")
};
export default {
  inject: ["eventBus"],

  components: {
    LoginModal,
    MainNavBar
  },
  data() {
    return {
      isActive: false,
      lastScrollPosition: 0
    };
  },

  methods: {
    handleClick() {
      this.$router.push({
        name: 'home'
      });
    },
    handleScroll: (event, el) => {
      if (window.scrollY >= 1) {
        el.classList.add("fixed");
      } else {
        el.classList.remove("fixed");
      }
    },
    toggleClass: function(event) {
      this.isActive = !this.isActive;
    },
    selectLogin: function(event) {
      this.$modal.show("login");
    },
    onScroll() {
      // Get the current scroll position
      const currentScrollPosition =
        window.pageYOffset || document.documentElement.scrollTop;
      // Because of momentum scrolling on mobiles, we shouldn't continue if it is less than zero
      if (currentScrollPosition < 0) {
        return;
      }
      // Here we determine whether we need to show or hide the navbar
      if (this.isActive) {
        this.isActive = currentScrollPosition < this.lastScrollPosition;
        // Set the current scroll position as the last scroll position
        this.lastScrollPosition = currentScrollPosition;
      }
    }
  },
  mounted() {
    window.addEventListener("scroll", this.onScroll);
  },
  beforeDestroy() {
    window.removeEventListener("scroll", this.onScroll);
  },
  computed: {
    logos() {
      return logos;
    }
  }
};
</script>

<style lang="scss" scoped>
@import url("https://fonts.googleapis.com/css?family=Quicksand:regular,500,600,700");
@import url("~@/assets/css/components.css");
@import url("~@/assets/css/normalize.css");
$desktop: 1200px;
$laptop: 1024px;
$tablet: 768px;
$mobile: 480px;

.header-image {
  position: relative;
  top: 5%;
}
.dropdown-links-container {
  display: flex;

  align-items: center;
  flex-direction: column;
  justify-content: space-between;
  height: 160px;
  border-radius: 0 0 1px 1px;
  background: #ffffff;
  visibility: hidden; /* hides sub-menu */
  opacity: 0;
  position: absolute;

  width: 100%;
  transform: translateY(-2em);
  list-style: none;
  padding: 19px;
  z-index: 10;
  transition: all 0.3s ease-in-out 0s, visibility 0s linear 0.3s,
    z-index 0s linear 0.01s;
}

.dropdown-nav-link {
  text-decoration: none;
  color: #000;
  text-align: left;
  text-transform: uppercase;
}

.nav-dropdown-content {
  position: absolute;
  background-color: white;
  font-family: bebas;
  color: #000;
  border-radius: 0 0 10px 10px;
  height: 0;
  width: 100%;
  transition: height 2s;
}
.header {
  background-color: transparent;
  z-index: 2;
}

.logo {
  cursor: pointer;
}

.nav__links a,
.cta,
.overlay__content a {
  font-family: "bebas", sans-serif;
  font-weight: 500;
  color: black;
  text-decoration: none;
  transition: all 2s;
}

.nav__links {
  list-style: none;
  display: flex;
  font-size: 20px;
  transition: all 2s;
  @media (max-width: $laptop) {
    font-size: 15px;
  }

  & ul {
    margin-bottom: 0 !important;
  }
}
.show {
  visibility: visible !important;
  opacity: 1 !important;
  transform: translateY(0%);
  top: 60px;
  z-index: 10;
  position: fixed;
  transition-delay: 0s, 0s, 0.3s;
}

.nav__links li {
  padding: 0px 20px;
}

.nav__links li a {
  transition: color 0.3s ease 0s;
}

.nav__links li a:hover {
  color: #0088a9;
}

.cta:hover {
  background-color: rgba(0, 136, 169, 0.8);
}

/* Mobile Nav */

.menu {
  display: none;
}

.overlay {
  height: 100%;
  width: 0;
  position: fixed;
  z-index: 1;
  left: 0;
  top: 0;
  background-color: #24252a;
  overflow-x: hidden;
  transition: width 0.5s ease 0s;
}

.overlay--active {
  width: 100%;
}

.overlay__content {
  display: flex;
  height: 100%;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.overlay a {
  padding: 15px;
  font-size: 36px;
  display: block;
  transition: color 0.3s ease 0s;
}

.overlay a:hover,
.overlay a:focus {
  color: #0088a9;
}
.overlay .close {
  position: absolute;
  top: 20px;
  right: 45px;
  font-size: 60px;
  color: #edf0f1;
}

@media screen and (max-height: 450px) {
  .overlay a {
    font-size: 20px;
  }
  .overlay .close {
    font-size: 40px;
    top: 15px;
    right: 35px;
  }
}

@media only screen and (max-width: 800px) {
  .nav__links,
  .mobile-hidden,
  .cta {
    display: none;
  }
  .menu {
    display: initial;
  }
}

.menu {
  margin-right: 30px;
}

.guide-wrapper {
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 64px;
  padding-top: 10px;
  font-family: Quicksand, sans-serif;
  text-transform: uppercase;
  @media (max-width: $mobile) {
    margin-right: 0;
    margin-left: 0;
    padding-top: 0;
    position: relative;
    z-index: 11;
    background-color: white;
  }
}

.guide-header {
  display: block;
  -webkit-justify-content: space-around;
  -ms-flex-pack: distribute;
  justify-content: space-around;
  -webkit-box-align: start;
  -webkit-align-items: flex-start;
  -ms-flex-align: start;
  align-items: flex-start;
  height: 100px;

  @media (max-width: $mobile) {
    height: 80px;
  }
}

.nav-container {
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: justify;
  -webkit-justify-content: space-between;
  -ms-flex-pack: justify;
  justify-content: space-between;
  -webkit-box-align: center;
  -webkit-align-items: center;
  -ms-flex-align: center;
  align-items: center;
}

.w-nav {
  background: transparent !important;
}

.navbar {
  display: block;
  padding-top: 10px;
  -webkit-box-pack: justify;
  -webkit-justify-content: space-between;
  -ms-flex-pack: justify;
  justify-content: space-between;
  -webkit-box-align: center;
  -webkit-align-items: center;
  -ms-flex-align: center;
  align-items: center;
  background-color: transparent;
  font-size: 20px;
  font-weight: 400;
}

.min-width-130px {
  min-width: 130px;
  margin-right: 20px;
  margin-left: 20px;
  font-family: Quicksand, sans-serif;
  color: #000;
  font-size: 18px;

  @media (max-width: $mobile) {
    margin-left: 0;
    margin-right: 0;
  }
}

.header-links {
  margin-left: 30px;
  font-family: Quicksand, sans-serif;
  color: #070505;
  text-decoration: none;
  @media (max-width: $mobile) {
    margin-left: 20px;
    position: relative;
    left: 55%;
  }
}

.fixed {
  position: fixed !important;
  top: 0;
  left: 0;
  width: 100%;
  background-color: rgba(245, 245, 245, 1) !important;
  box-shadow: 0 2px 2px #efefef;
  z-index: 9999;
  transition: 1s;
}

nav {
  top: 50px;
}
nav a {
  text-transform: uppercase;
  text-decoration: none;
  color: #16151b;
  margin: 0 15px;
  letter-spacing: 1px;
  position: relative;
  display: inline-block;
}
nav a:not(.change-new):before {
  content: "";
  position: absolute;
  width: 100%;
  height: 3px;
  background: #16151b;
  top: 47%;
  animation: out 0.5s cubic-bezier(0.25, 0.1, 0.25, 1) 1 both;
}
nav a:not(.change-new):hover:before {
  animation: in 0.5s cubic-bezier(0.25, 0.1, 0.25, 1) 1 both;
}
@keyframes in {
  0% {
    width: 0;
    left: 0;
    right: auto;
  }
  100% {
    left: 0;
    right: auto;
    width: 100%;
  }
}
@keyframes out {
  0% {
    width: 100%;
    left: auto;
    right: 0;
  }
  100% {
    width: 0;
    left: auto;
    right: 0;
  }
}
@keyframes show {
  0% {
    opacity: 0;
    transform: translateY(-10px);
  }
  100% {
    opacity: 1;
    transform: translateY(0);
  }
}

@for $i from 1 through 7 {
  nav a:not(.change-new):nth-child(#{$i}) {
    animation: show 0.2s #{$i * 0.1+1}s ease 1 both;
  }
}

.change-new {
  opacity: 0 !important;
  position: absolute;
  left: 40px;
}
.text-change:hover .change-old {
  opacity: 0 !important;
}
.text-change:hover .change-new {
  opacity: 1 !important;
}
.change-old,
.change-new {
  transition: opacity 0.1s !important;
}
/* .upper-header {
  background-color: white;
  display: flex;
  justify-content: space-around;
  align-items: center;
}
hr {
  opacity: 0.2;
  margin-top: 10px;
  width: 100%;
  height: 0.2px;
  margin-right: auto;
  margin-left: auto;
  background-color: black;
}
.header-icon {
  font-size: 32px;
}

.menu-items {
  display: flex;
}

.ant-menu-item {
  text-transform: uppercase;
}

.fuji-logo {
  height: auto;
  margin: 20px;
  width: 300px;
}

.phone-time {
  margin: 1%;
}

.menu-items {
  margin: 1%;
}
.sushi-banner {
  width: 100%;
  height: 250px;
  object-fit: cover;
} */
</style>
